// extracted by mini-css-extract-plugin
export default {"page-wrapper":"AdminLayout_page-wrapper__SgOQn"};